import React, { useState, useEffect, useMemo, useCallback } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave, FaTrash, FaPlus, FaUpload, FaCalendarAlt, FaDollarSign, FaStickyNote, FaFileInvoiceDollar, FaHotel, FaUtensils, FaCog, FaMapMarkerAlt, FaClock, FaArrowLeft, FaFileExcel, FaSearch, FaTimes } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { data, dataMysql, pontoVirgula } from '../../util/util';
import ReactInputMask from 'react-input-mask';
import '../../css/financeiro-parcela-pagar.css';


// Função para sanitizar entrada numérica (aceita vírgula e ponto)
const sanitizeNumber = (value) => {
    if (!value) return '';
    // Remove caracteres não numéricos exceto vírgula, ponto e sinal negativo
    return value.toString().replace(/[^0-9.,-]/g, '').replace(',', '.');
};

// Função para formatar exibição de percentual
const formatPercent = (value) => {
    const num = parseFloat(value) || 0;
    return num.toString();
};

export default function CadastroEventoOrdemServico({ match }) {
    const idEvento = match.params.idEvento;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!idEvento);
    // Busca nome do evento do localStorage, se existir
    let nomeEventoLS = '';
    try {
        const eventoLS = JSON.parse(localStorage.getItem('eventoSelecionado'));
        if (eventoLS && String(eventoLS.id) === String(idEvento)) {
            nomeEventoLS = eventoLS.nome || '';
        }
    } catch { }
    const [informacoesEvento, setInformacoesEvento] = useState({ nome: nomeEventoLS, id: '' }); // Para header
    const [salas, setSalas] = useState([]);
    const [abs, setAbs] = useState([]);
    const [eventos, setEventos] = useState([]);
    const [montagemEventos, setMontagemEventos] = useState([]);
    const [valoresAcordados, setValoresAcordados] = useState([]);
    const [configuracoesPorData, setConfiguracoesPorData] = useState({});
    // start empty; users add items explicitly
    const [observacoesGerais, setObservacoesGerais] = useState([]);
    const [informacoesNF, setInformacoesNF] = useState([]);
    // Estados para listas de fornecedores (serão populados via API)
    const [fornecedoresEquipamento, setFornecedoresEquipamento] = useState([]);
    const [fornecedoresCenografia, setFornecedoresCenografia] = useState([]);
    const [contatoNome, setContatoNome] = useState('');
    const [contatoTelefone, setContatoTelefone] = useState('');
    const [nextObsId, setNextObsId] = useState(1);
    const [nextNfId, setNextNfId] = useState(1);
    const [ordemServicoId, setOrdemServicoId] = useState(null); // ID da ordem de serviço para upsert
    const [salvandoDados, setSalvandoDados] = useState(false); // Estado para loading do botão
    const [abaAtiva, setAbaAtiva] = useState('valores-acordados');
    const [subAbaAtiva, setSubAbaAtiva] = useState('salas'); // 'salas' | 'ab'
    const history = useHistory();

    // Itens fixos para Notas Fiscais
    const itensFixosNF = [
        "O documento de cobrança só pode ser emitido após validação do relatório de fechamento pela agência de logística que estiver cuidando do evento + requisitante Sanofi;",
        "Sanofi efetua os pagamentos somente as 4ª feiras (se não coincidir a data, o vencimento deverá ajustado sempre para a próxima 4ª feira útil);",
        "Pagamentos somente via transferência bancária;",
        "CNPJ indicado para emissão do pedido de compras deve ser o mesmo da emissão de NF. Assim como a conta bancária atrelada a esse CNPJ;",
        "Cada NF e somente a NF deve ser enviada com cópia para o e-mail da solicitante no seguinte formato:",
        "A descrição do serviço na NF deve ser exatamente a que consta no Pedido de Compra Quaisquer outros detalhes podem ser inclusos na nota mas não na linha de descrição.",
        "O(s) número(s) do pedido de compras deve obrigatoriamente constar na NF.",
        "O Pedido de compras é enviado automaticamente, caso não tenha recebido favor nos informar",
        "Se houver mais de um pedido de compras para o mesmo evento e mesmo CNPJ, o documento de cobrança deve constar ambos os números dos pedidos de compras;",
        "Após o evento, se houver valores extras, precisaremos ajustar o pedido de compras. Incluir budget e a NF só pode ser emitida depois desse ajuste, por isso a importância do fechamento ser logo após o evento. Os documentos de cobrança dessas despesas extras não poderão ser emitidos ate que isso esteja ajustado, pois a requisitante não consegue dar entrada na NF em um pedido que tem um saldo inferior ao documento e nosso Financeiro não aceita documentos que a data de emissão da NF seja anterior a data de ajuste do pedido.",
        "Danfe: como o pedido de compras é criado como serviço, após o fechamento a requisitante precisará ter visibilidade da Danfe para podermos ajustá-lo."
    ];

    // Funções helper
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value || 0);
    };

    const getCategoriaColor = (categoria) => {
        const colors = {
            'Hospedagem': 'is-info',
            'Equipamentos': 'is-muted',
            'Outros': 'is-muted'
        };
        return colors[categoria] || 'is-muted';
    };

    // NOVO: extrair valores acordados do snapshot (salas_configuracoes) - backend removeu campo flatten 'valoresAcordados'
    const extrairValoresAcordadosDoSnapshot = (dadosRecebidos) => {
        try {
            // 1) Legacy direto ainda presente?
            if (Array.isArray(dadosRecebidos?.valoresAcordados)) {
                return dadosRecebidos.valoresAcordados.map((valor, index) => mapItemValor(valor, index));
            }

            // 2) Snapshot em salas_configuracoes
            const snapshot = (dadosRecebidos?.salas_configuracoes || [])[0];
            if (!snapshot) return [];
            let estrutura = snapshot.valores_acordados || [];
            if (estrutura && typeof estrutura === 'string') {
                try { estrutura = JSON.parse(estrutura); } catch { }
            }
            let itens = [];
            if (Array.isArray(estrutura?.itens)) {
                itens = estrutura.itens;
            } else if (Array.isArray(estrutura)) {
                itens = estrutura; // fallback legacy
            }
            return itens.map((valor, index) => mapItemValor(valor, index));
        } catch (e) {
            console.warn('Falha ao extrair valores acordados do snapshot', e);
            return [];
        }
    };

    // Mapeia item bruto (snapshot) -> estrutura usada pelo estado valoresAcordados
    const mapItemValor = (item, index) => {
        const base = parseFloat(item?.valor ?? item?.valorTotal ?? 0) || 0;
        // Percentuais podem vir como decimal (0.05) em impostoPercentual / txServicoPercentual
        let impostoPerc = 0;
        if (item?.impostoPercentual !== undefined) impostoPerc = item.impostoPercentual * 100;
        else if (item?.imposto !== undefined && item.imposto <= 1) impostoPerc = item.imposto * 100; // legacy
        else if (item?.valorImposto && base > 0) impostoPerc = (item.valorImposto / base) * 100;
        let txServicoPerc = 0;
        if (item?.txServicoPercentual !== undefined) txServicoPerc = item.txServicoPercentual * 100;
        else if (item?.txServico !== undefined && item.txServico <= 1) txServicoPerc = item.txServico * 100; // legacy
        else if (item?.valorTaxaServico && base > 0) txServicoPerc = (item.valorTaxaServico / base) * 100;
        return {
            id: index + 1,
            categoria: item?.categoria || 'Outros',
            titulo: item?.titulo || '',
            item: item?.descricao || item?.item || '',
            valor: base.toString(),
            imposto: impostoPerc.toString(),
            txServico: txServicoPerc.toString(),
            observacao: item?.observacao || item?.obs || ''
        };
    };

    // Datas utilitárias
    const isValidIsoDate = (iso) => {
        if (!iso) return false;
        const d = new Date(`${iso}T00:00:00`);
        return !isNaN(d.getTime());
    };

    const addDays = (iso, increment) => {
        const d = new Date(`${iso}T00:00:00`);
        d.setDate(d.getDate() + increment);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const getDateRange = useCallback((startIso, endIso) => {
        if (!isValidIsoDate(startIso) || !isValidIsoDate(endIso)) return [];
        let start = startIso;
        let end = endIso;
        // Swap if inverted
        if (new Date(`${start}T00:00:00`) > new Date(`${end}T00:00:00`)) {
            [start, end] = [end, start];
        }
        const days = [];
        let cur = start;
        while (new Date(`${cur}T00:00:00`) <= new Date(`${end}T00:00:00`)) {
            days.push(cur);
            cur = addDays(cur, 1);
        }
        return days;
    }, []);

    const formatDateBR = (iso) => {
        if (!isValidIsoDate(iso)) return '';
        const [y, m, d] = iso.split('-');
        return `${d}/${m}`;
    };

    const formatWeekdayLong = (iso) => {
        if (!isValidIsoDate(iso)) return '';
        const d = new Date(`${iso}T00:00:00`);
        return d.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' });
    };

    // Helpers to detect blank values and filter out essentially-empty items
    const isBlank = (v) => v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

    const filterSalasArray = (arr) => (arr || []).filter(s => {
        // consider sala meaningful if any main field has content
        return !(isBlank(s.salaTitulo) && isBlank(s.salaNome) && isBlank(s.layoutMontagem) && isBlank(s.equipamentos) && isBlank(s.observacoes));
    });

    const filterAbsArray = (arr) => (arr || []).filter(a => {
        return !(isBlank(a.abNome) && isBlank(a.abLocal) && isBlank(a.horario) && isBlank(a.composicao));
    });

    const filterEventosArray = (arr) => (arr || []).filter(e => {
        return !(isBlank(e.eventoNome) && isBlank(e.eventoLocal));
    });

    const filterMontagemArray = (arr) => (arr || []).filter(m => {
        return !(isBlank(m.montagemEventoNome) && isBlank(m.montagemEventoLocal));
    });

    // Contadores/indicadores por aba
    const countItemsForDate = (dateIso) => {
        const salasCount = salas.filter(s => (s?.datas ?? []).includes(dateIso)).length;
        const absCount = abs.filter(a => (a?.datas ?? []).includes(dateIso)).length;
        const eventosCount = eventos.filter(e => (e?.datas ?? []).includes(dateIso)).length;
        const montagemEventosCount = montagemEventos.filter(m => (m?.datas ?? []).includes(dateIso)).length;
        return salasCount + absCount + eventosCount + montagemEventosCount;
    };

    const getAbaCount = (abaId) => {
        if (abaId === 'valores-acordados') return valoresAcordados.length;
        if (abaId === 'observacoes') return observacoesGerais.filter(x => (x.texto || '').toString().trim().length > 0).length;
        if (abaId === 'nf') return informacoesNF.filter(x => (x.texto || '').toString().trim().length > 0).length;
        if (abaId.startsWith('dia-')) {
            const dateIso = abaId.replace('dia-', '');
            return countItemsForDate(dateIso);
        }
        return 0;
    };

    // Componente de Select Simples com Modal de Busca - NOVA ABORDAGEM
    const SelectSimples = ({
        value,
        onChange,
        fornecedores,
        placeholder,
        label,
        salaIndex,
        tipo
    }) => {
        const [showModal, setShowModal] = useState(false);
        const [busca, setBusca] = useState('');

        const fornecedorSelecionado = fornecedores.find(f => f.id.toString() === value.toString());
        const nomeExibido = fornecedorSelecionado ? fornecedorSelecionado.nome : '';

        // Filtrar fornecedores baseado na busca
        const fornecedoresFiltrados = fornecedores.filter(fornecedor =>
            fornecedor.nome.toLowerCase().includes(busca.toLowerCase())
        );

        const abrirModal = () => {
            setShowModal(true);
            setBusca('');
        };

        const fecharModal = () => {
            setShowModal(false);
            setBusca('');
        };

        const selecionarFornecedor = (fornecedor) => {
            onChange(fornecedor.id);
            fecharModal();
        };

        const limparSelecao = () => {
            onChange('');
            fecharModal();
        };

        return (
            <>
                <div className="fin-pp__field">
                    <span className="fin-pp__label">{label}</span>
                    <div style={{
                        border: '1px solid var(--fin-bdr)', borderRadius: 8, background: '#fff',
                        height: 44, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        paddingLeft: 14, paddingRight: 14, cursor: 'pointer', fontSize: 14,
                        color: value ? 'var(--fin-tx)' : 'var(--fin-mt)'
                    }} onClick={abrirModal}>
                        <span>{nomeExibido || placeholder}</span>
                        <FaSearch size={14} style={{ color: 'var(--fin-mt)', flexShrink: 0 }} />
                    </div>
                </div>

                {/* Modal de Busca */}
                {showModal && (
                    <div
                        className="modal show d-block fin-pp fin-pp__modalbg"
                        style={{ zIndex: 1060 }}
                        onClick={fecharModal}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-lg"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaSearch size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Selecionar {label}</h3>
                                    <button
                                        type="button"
                                        className="fin-pp__modal-close"
                                        onClick={fecharModal}
                                    ><FaTimes size={16} /></button>
                                </div>

                                <div className="modal-body">
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="fin-pp__input"
                                            style={{ paddingLeft: 14 }}
                                            placeholder="Digite para buscar fornecedor..."
                                            value={busca}
                                            onChange={(e) => setBusca(e.target.value)}
                                            autoFocus
                                        />
                                    </div>

                                    {value && (
                                        <div style={{ marginBottom: 14 }}>
                                            <button
                                                type="button"
                                                className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                                onClick={limparSelecao}
                                            >
                                                <FaTimes size={12} style={{ marginRight: 4 }} /> Limpar seleção
                                            </button>
                                        </div>
                                    )}

                                    <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                                        {fornecedoresFiltrados.length === 0 ? (
                                            <div style={{ textAlign: 'center', padding: '32px', color: 'var(--fin-mt)' }}>
                                                <p>Nenhum fornecedor encontrado para "{busca}"</p>
                                            </div>
                                        ) : (
                                            <div>
                                                {fornecedoresFiltrados.map((fornecedor) => (
                                                    <button
                                                        key={fornecedor.id}
                                                        type="button"
                                                        style={{
                                                            width: '100%', textAlign: 'left', padding: '10px 14px',
                                                            border: 'none',
                                                            background: String(value) === String(fornecedor.id) ? 'var(--fin-acw)' : 'transparent',
                                                            borderBottom: '1px solid var(--fin-bdr)',
                                                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                            cursor: 'pointer', color: 'var(--fin-tx)'
                                                        }}
                                                        onClick={() => selecionarFornecedor(fornecedor)}
                                                    >
                                                        <span>{fornecedor.nome}</span>
                                                        {String(value) === String(fornecedor.id) && (
                                                            <span style={{ color: 'var(--fin-ok)', fontSize: 16 }}>✓</span>
                                                        )}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="fin-pp__modal-foot">
                                    <button
                                        type="button"
                                        className="fin-pp__btn"
                                        onClick={fecharModal}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const calcularValorTotal = () => {
        return valoresAcordados.reduce((total, item) => {
            const valorBase = parseFloat(item.valor) || 0;
            // Converter percentuais de string para decimal (ex: "3.75" -> 0.0375)
            const impostoPercent = (parseFloat(item.imposto) || 0) / 100;
            const taxaServicoPercent = (parseFloat(item.txServico) || 0) / 100;
            const imposto = valorBase * impostoPercent;
            const taxaServico = valorBase * taxaServicoPercent;
            return total + valorBase + imposto + taxaServico;
        }, 0);
    };



    const organizarDadosParaEnvio = () => {
        // Organizar valores acordados com cálculos
        const valoresAcordadosOrganizados = valoresAcordados.map(item => {
            const valorBase = parseFloat(item.valor) || 0;
            const impostoPercent = (parseFloat(item.imposto) || 0) / 100; // decimal
            const txServicoPercent = (parseFloat(item.txServico) || 0) / 100; // decimal
            const valorImposto = +(valorBase * impostoPercent);
            const valorTaxaServico = +(valorBase * txServicoPercent);
            const valorTotal = +(valorBase + valorImposto + valorTaxaServico);
            return {
                categoria: item.categoria,
                titulo: item.titulo || '',
                descricao: item.item || '',
                valor: valorBase,
                valorTotal,
                impostoPercentual: impostoPercent,
                txServicoPercentual: txServicoPercent,
                valorImposto,
                valorTaxaServico,
                observacao: item.observacao || ''
            };
        });

        // Organizar configurações por data - SEMPRE usar o período do evento
        const configuracoesPorData = {};

        // SEMPRE usar o período do evento definido nas datas de início e fim
        const datasParaProcessar = getDateRange(dados.dataInicio, dados.dataFim);
        console.log('Processando dados para o período do evento:', datasParaProcessar);

        datasParaProcessar.forEach(dataIso => {
            const salasData = salas.filter(s => (s?.datas ?? []).includes(dataIso));
            const absData = abs.filter(a => (a?.datas ?? []).includes(dataIso));
            const eventosData = eventos.filter(e => (e?.datas ?? []).includes(dataIso));
            const montagemEventosData = montagemEventos.filter(m => (m?.datas ?? []).includes(dataIso));

            configuracoesPorData[dataIso] = {
                salas: salasData.map(sala => {
                    const salaObj = {
                        salaTitulo: sala.salaTitulo || sala.local || '',
                        salaNome: sala.salaNome || sala.atividade || '',
                        // Usar campos que já existem no backend
                        layoutMontagem: sala.layout || '',
                        equipamentos: sala.equipamento || '',
                        observacoes: sala.observacao || '',
                        // Novos campos específicos que não têm equivalente
                        horario: sala.horario || '',
                        cenografia: sala.cenografia || '',
                        datas: sala.datas || [dataIso]
                    };
                    // Persistir camposDinamicos se existirem e não vazios
                    if (Array.isArray(sala.camposDinamicos) && sala.camposDinamicos.length > 0) {
                        const camposFiltrados = sala.camposDinamicos.filter(c => c.key && c.key.trim() !== '');
                        if (camposFiltrados.length > 0) {
                            salaObj.camposDinamicos = camposFiltrados;
                        }
                    }
                    return salaObj;
                }),
                alimentacaoBebidas: absData.map(ab => {
                    const abObj = {
                        abNome: ab.abNome || ab.atividade || '',
                        abLocal: ab.abLocal || ab.local || '',
                        valor: parseFloat(ab.valor) || 0,
                        quantidade: parseInt(ab.quantidade) || 1,
                        composicao: ab.composicao || '',
                        horario: ab.horario || '',
                        local: ab.local || '',
                        // Novos campos fixos para A&B - usar campos que já existem no backend
                        layoutMontagem: ab.layout || '',
                        equipamentos: ab.equipamento || '',
                        observacoes: ab.observacao || '',
                        // Novos campos específicos que não têm equivalente
                        cenografia: ab.cenografia || '',
                        datas: ab.datas || [dataIso]
                    };
                    // Persistir camposDinamicos se existirem e não vazios
                    if (Array.isArray(ab.camposDinamicos) && ab.camposDinamicos.length > 0) {
                        abObj.camposDinamicos = ab.camposDinamicos.filter(c => c.key && c.key.trim() !== '');
                    }
                    return abObj;
                }),
                eventos: eventosData.map(evento => {
                    const eventoObj = {
                        eventoNome: evento.eventoNome || evento.atividade || '',
                        eventoLocal: evento.eventoLocal || evento.local || '',
                        // Novos campos fixos para Eventos - usar campos que já existem no backend
                        layoutMontagem: evento.layout || '',
                        equipamentos: evento.equipamento || '',
                        observacoes: evento.observacao || '',
                        // Novos campos específicos que não têm equivalente
                        horario: evento.horario || '',
                        cenografia: evento.cenografia || '',
                        datas: evento.datas || [dataIso]
                    };
                    // Persistir camposDinamicos se existirem e não vazios
                    if (Array.isArray(evento.camposDinamicos) && evento.camposDinamicos.length > 0) {
                        const camposFiltrados = evento.camposDinamicos.filter(c => c.key && c.key.trim() !== '');
                        if (camposFiltrados.length > 0) {
                            eventoObj.camposDinamicos = camposFiltrados;
                        }
                    }
                    return eventoObj;
                }),
                montagemEventos: montagemEventosData.map(montagem => {
                    const montagemObj = {
                        montagemEventoNome: montagem.montagemEventoNome || montagem.atividade || '',
                        montagemEventoLocal: montagem.montagemEventoLocal || montagem.local || '',
                        // Novos campos fixos para Montagem + Evento - usar campos que já existem no backend
                        layoutMontagem: montagem.layout || '',
                        equipamentos: montagem.equipamento || '',
                        observacoes: montagem.observacao || '',
                        // Novos campos específicos que não têm equivalente
                        horario: montagem.horario || '',
                        cenografia: montagem.cenografia || '',
                        datas: montagem.datas || [dataIso]
                    };
                    // Persistir camposDinamicos se existirem e não vazios
                    if (Array.isArray(montagem.camposDinamicos) && montagem.camposDinamicos.length > 0) {
                        const camposFiltrados = montagem.camposDinamicos.filter(c => c.key && c.key.trim() !== '');
                        if (camposFiltrados.length > 0) {
                            montagemObj.camposDinamicos = camposFiltrados;
                        }
                    }
                    return montagemObj;
                })
            };
        });

        console.log('=== DEBUG CONTATO ===');
        console.log('contatoNome:', contatoNome);
        console.log('contatoTelefone:', contatoTelefone);

        // Estrutura completa do JSON
        const jsonOrganizado = {
            eventoId: idEvento,
            // Incluir ordemServico se existir para fazer upsert
            ...(ordemServicoId && { ordemServico: ordemServicoId }),
            informacoesGerais: {
                dataInicio: dados.dataInicio || '',
                dataFim: dados.dataFim || '',
                contatoNome: contatoNome || '',
                contatoTelefone: contatoTelefone || ''
            },
            valoresAcordados: {
                itens: valoresAcordadosOrganizados
            },
            configuracoesPorData: configuracoesPorData,
            observacoesGerais: observacoesGerais.filter(obs => obs.texto && obs.texto.trim() !== '').map(obs => ({
                titulo: obs.titulo || '',
                texto: obs.texto
            })),
            informacoesNotaFiscal: informacoesNF.filter(info => info.texto && info.texto.trim() !== '').map(info => ({
                texto: info.texto,
                isFixo: info.isFixo || false
            })),
            resumoGeral: {
                totalSalas: salas.length,
                totalAlimentacaoBebidas: abs.length,
                totalEventos: eventos.length,
                totalMontagemEventos: montagemEventos.length,
                totalItensConfigurados: salas.length + abs.length + eventos.length + montagemEventos.length
            }
        };

        console.log('=== DEBUG JSON COMPLETO SENDO ENVIADO ===');
        console.log('jsonOrganizado.informacoesGerais:', jsonOrganizado.informacoesGerais);
        console.log('JSON completo:', JSON.stringify(jsonOrganizado, null, 2));

        return jsonOrganizado;
    };

    const salvar = () => {
        setSalvandoDados(true); // Desabilitar botão durante o envio

        // Organizar todos os dados em um JSON estruturado
        const jsonOrganizado = organizarDadosParaEnvio();

        // Log específico das datas para debug
        console.log('=== DEBUG DATAS ===');
        console.log('Data Início:', dados.dataInicio);
        console.log('Data Fim:', dados.dataFim);
        console.log('Salas e suas datas:', salas.map(s => ({ local: s.local || s.salaTitulo, datas: s.datas })));
        console.log('Configurações por data:', Object.keys(jsonOrganizado.configuracoesPorData));
        console.log('===================');

        // Log do JSON organizado no console para verificação
        console.log('JSON Organizado para envio:', JSON.stringify(jsonOrganizado, null, 2));
        console.log('Ordem de Serviço ID:', ordemServicoId ? `Incluindo ID: ${ordemServicoId} (UPDATE)` : 'Sem ID (CREATE)');
        console.log('Campo ordemServico no payload:', jsonOrganizado.ordemServico ? `Presente: ${jsonOrganizado.ordemServico}` : 'Ausente');

        // Debug específico dos novos campos de sala
        console.log('=== DEBUG NOVOS CAMPOS DE SALA ===');
        Object.entries(jsonOrganizado.configuracoesPorData).forEach(([data, config]) => {
            if (config.salas && config.salas.length > 0) {
                config.salas.forEach((sala, index) => {
                    console.log(`Sala ${index + 1} em ${data}:`, {
                        salaTitulo: sala.salaTitulo,
                        salaNome: sala.salaNome,
                        layoutMontagem: sala.layoutMontagem,
                        horario: sala.horario,
                        equipamentos: sala.equipamentos,
                        cenografia: sala.cenografia,
                        observacoes: sala.observacoes
                    });
                });
            }
            if (config.alimentacaoBebidas && config.alimentacaoBebidas.length > 0) {
                config.alimentacaoBebidas.forEach((ab, index) => {
                    console.log(`A&B ${index + 1} em ${data}:`, {
                        abNome: ab.abNome,
                        abLocal: ab.abLocal,
                        layoutMontagem: ab.layoutMontagem,
                        horario: ab.horario,
                        equipamentos: ab.equipamentos,
                        cenografia: ab.cenografia,
                        observacoes: ab.observacoes
                    });
                });
            }
            if (config.eventos && config.eventos.length > 0) {
                config.eventos.forEach((evento, index) => {
                    console.log(`Evento ${index + 1} em ${data}:`, {
                        eventoNome: evento.eventoNome,
                        eventoLocal: evento.eventoLocal,
                        layoutMontagem: evento.layoutMontagem,
                        horario: evento.horario,
                        equipamentos: evento.equipamentos,
                        cenografia: evento.cenografia,
                        observacoes: evento.observacoes
                    });
                });
            }
        });
        console.log('===================================');

        // Chamar o novo endpoint com o JSON completo
        api({
            method: 'post',
            action: '/eventoOrdemServicoPack',
            token: token,
            data: jsonOrganizado
        })
            .then((response) => {
                console.log('Resposta do servidor:', response.data);

                // Capturar o ID da ordem de serviço retornado pelo backend
                if (response.data.data && response.data.data.ordemId) {
                    setOrdemServicoId(response.data.data.ordemId);
                }

                // Exibir toast de sucesso
                toast.success('Ordem de Serviço salva com sucesso!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                });

                // Manter na mesma tela após salvar (melhor UX)
                console.log('Ordem de Serviço salva com sucesso!');
            })
            .catch((error) => {
                console.error('Erro ao salvar:', error);
                console.error('Detalhes do erro:', error.response?.data);

                // Exibir toast de erro
                const mensagemErro = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido';
                toast.error(`Erro ao salvar Ordem de Serviço: ${mensagemErro}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                });

            })
            .finally(() => {
                setSalvandoDados(false); // Reabilitar botão
            });
    };

    const exportarOrdemServico = async () => {
        if (!ordemServicoId) {
            toast.error('Não é possível exportar: Ordem de Serviço não encontrada', {
                position: "top-right",
                autoClose: 3000
            });
            return;
        }

        try {
            setSalvandoDados(true); // Usar o mesmo estado para desabilitar botões

            toast.info('Gerando arquivo Excel...', {
                position: "top-right",
                autoClose: 2000
            });

            const response = await fetch(`${process.env.REACT_APP_API_URL}/evento/exportarOrdemServicoFull/${ordemServicoId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                // Nome do arquivo com informações do evento
                const nomeEvento = informacoesEvento.nome || 'Evento';
                const dataAtual = new Date().toISOString().slice(0, 10);
                link.download = `OrdemServico_${nomeEvento.replace(/[^a-zA-Z0-9]/g, '_')}_${dataAtual}.xlsx`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                toast.success('Excel exportado com sucesso!', {
                    position: "top-right",
                    autoClose: 3000
                });
            } else {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Erro no servidor');
            }
        } catch (error) {
            console.error('Erro ao exportar:', error);
            toast.error(`Erro ao exportar: ${error.message}`, {
                position: "top-right",
                autoClose: 5000
            });
        } finally {
            setSalvandoDados(false);
        }
    };


    const buscar = () => {
        setIsLoading(true);
        try {
            console.log('Buscando ordem de serviço para evento:', idEvento);
            // Tentar primeiro o endpoint original, se falhar, tentar o endpoint Pack
            api({
                method: "get",
                action: '/eventoOrdemServico/' + idEvento,
                token: token,
            }).then(response => {
                const dadosRecebidos = response.data.data;
                console.log('Dados recebidos:', dadosRecebidos);
                console.log('Estrutura completa da resposta:', JSON.stringify(response.data, null, 2));

                // Capturar o ID da ordem de serviço se existir - verificar diferentes possíveis nomes
                if (dadosRecebidos.ordemServico) {
                    console.log('Encontrado ordemServico:', dadosRecebidos.ordemServico);
                    setOrdemServicoId(dadosRecebidos.ordemServico);
                } else if (dadosRecebidos.ordemId) {
                    console.log('Encontrado ordemId:', dadosRecebidos.ordemId);
                    setOrdemServicoId(dadosRecebidos.ordemId);
                } else if (dadosRecebidos.id) {
                    console.log('Encontrado id:', dadosRecebidos.id);
                    setOrdemServicoId(dadosRecebidos.id);
                } else if (response.data.ordemId) {
                    console.log('Encontrado ordemId no response.data:', response.data.ordemId);
                    setOrdemServicoId(response.data.ordemId);
                } else if (response.data.ordemServico) {
                    console.log('Encontrado ordemServico no response.data:', response.data.ordemServico);
                    setOrdemServicoId(response.data.ordemServico);
                } else {
                    console.log('Nenhum ID de ordem encontrado nos dados');
                    setOrdemServicoId(null);
                }

                // Capturar informações do evento para o header
                if (dadosRecebidos.evento) {
                    setInformacoesEvento({
                        nome: dadosRecebidos.evento.nome || 'Evento sem nome',
                        id: dadosRecebidos.evento.id || idEvento
                    });
                }

                // Se houver informacoesGerais, usar as datas de lá, senão usar do evento
                console.log('Dados recebidos:', dadosRecebidos);
                console.log('informacoesGerais:', dadosRecebidos.informacoesGerais);
                console.log('=== DEBUG: Carregando dados de contato ===');
                console.log('contato_nome do root:', dadosRecebidos.contato_nome);
                console.log('contato_telefone do root:', dadosRecebidos.contato_telefone);

                if (dadosRecebidos.informacoesGerais) {
                    console.log('Usando datas do informacoesGerais');
                    setDados({
                        dataInicio: dadosRecebidos.informacoesGerais.dataInicio ? dadosRecebidos.informacoesGerais.dataInicio.split('T')[0] : '',
                        dataFim: dadosRecebidos.informacoesGerais.dataFim ? dadosRecebidos.informacoesGerais.dataFim.split('T')[0] : '',
                        checkin: dadosRecebidos.checkin || ''
                    });
                    // Carregar dados de contato se existirem - priorizar informacoesGerais, fallback para root
                    setContatoNome(dadosRecebidos.informacoesGerais.contatoNome || dadosRecebidos.contato_nome || '');
                    setContatoTelefone(dadosRecebidos.informacoesGerais.contatoTelefone || dadosRecebidos.contato_telefone || '');
                } else if (dadosRecebidos.evento) {
                    console.log('Usando datas do evento (fallback)');
                    setDados({
                        dataInicio: dadosRecebidos.evento.data ? dadosRecebidos.evento.data.split(' ')[0] : '',
                        dataFim: dadosRecebidos.evento.dataFim ? dadosRecebidos.evento.dataFim.split(' ')[0] : '',
                        checkin: dadosRecebidos.checkin || ''
                    });
                    // Carregar dados de contato da ordem se existirem
                    setContatoNome(dadosRecebidos.contato_nome || '');
                    setContatoTelefone(dadosRecebidos.contato_telefone || '');
                } else {
                    setDados(dadosRecebidos);
                    // Carregar dados de contato da ordem se existirem
                    setContatoNome(dadosRecebidos.contato_nome || '');
                    setContatoTelefone(dadosRecebidos.contato_telefone || '');
                }

                // Log final dos dados carregados
                console.log('=== DEBUG: Dados de contato carregados ===');
                console.log('contatoNome final:', dadosRecebidos.informacoesGerais?.contatoNome || dadosRecebidos.contato_nome);
                console.log('contatoTelefone final:', dadosRecebidos.informacoesGerais?.contatoTelefone || dadosRecebidos.contato_telefone);

                // Processar configurações por data se existirem
                if (dadosRecebidos.configuracoesPorData) {
                    console.log('Configurações por data recebidas:', dadosRecebidos.configuracoesPorData);

                    const configPorData = typeof dadosRecebidos.configuracoesPorData === 'string'
                        ? JSON.parse(dadosRecebidos.configuracoesPorData)
                        : dadosRecebidos.configuracoesPorData;

                    // Extrair itens únicos organizados por tipo
                    const salasUnicas = {};
                    const absUnicas = {};
                    const eventosUnicos = {};
                    const montagemEventosUnicos = {};

                    if (configPorData && typeof configPorData === 'object') {
                        Object.entries(configPorData).forEach(([data, config]) => {
                            // Processar salas - usar dados dos arrays principais se configuracoesPorData estiver vazio
                            if (config.salas && Array.isArray(config.salas) && config.salas.length > 0) {
                                console.log(`Processando ${config.salas.length} salas para ${data}:`, config.salas);
                                config.salas.forEach(sala => {
                                    console.log('Sala recebida do backend:', {
                                        salaTitulo: sala.salaTitulo,
                                        layoutMontagem: sala.layoutMontagem,
                                        equipamentos: sala.equipamentos,
                                        observacoes: sala.observacoes,
                                        horario: sala.horario,
                                        cenografia: sala.cenografia
                                    });
                                    const chave = `${sala.salaTitulo || ''}|${sala.salaNome || ''}`;
                                    if (!salasUnicas[chave]) {
                                        salasUnicas[chave] = {
                                            salaTitulo: sala.salaTitulo || '',
                                            salaNome: sala.salaNome || '',
                                            layoutMontagem: sala.layoutMontagem || '',
                                            equipamentos: sala.equipamentos || '',
                                            observacoes: sala.observacoes || '',
                                            // Novos campos fixos - mapear do backend
                                            layout: sala.layoutMontagem || '',
                                            horario: sala.horario || '',
                                            equipamento: sala.equipamentos || '',
                                            cenografia: sala.cenografia || '',
                                            observacao: sala.observacoes || '',
                                            datas: [],
                                            // Carregar camposDinamicos se vier do backend
                                            camposDinamicos: Array.isArray(sala.camposDinamicos) ? sala.camposDinamicos : []
                                        };
                                    } else {
                                        // Se já existe, atualizar os campos se necessário
                                        if (Array.isArray(sala.camposDinamicos) && sala.camposDinamicos.length > 0) {
                                            salasUnicas[chave].camposDinamicos = sala.camposDinamicos;
                                        }
                                        // Atualizar novos campos se existirem
                                        if (sala.horario) salasUnicas[chave].horario = sala.horario;
                                        if (sala.cenografia) salasUnicas[chave].cenografia = sala.cenografia;
                                        if (sala.layoutMontagem) {
                                            salasUnicas[chave].layoutMontagem = sala.layoutMontagem;
                                            salasUnicas[chave].layout = sala.layoutMontagem;
                                        }
                                        if (sala.equipamentos) {
                                            salasUnicas[chave].equipamentos = sala.equipamentos;
                                            salasUnicas[chave].equipamento = sala.equipamentos;
                                        }
                                        if (sala.observacoes) {
                                            salasUnicas[chave].observacoes = sala.observacoes;
                                            salasUnicas[chave].observacao = sala.observacoes;
                                        }
                                    }
                                    salasUnicas[chave].datas.push(data);
                                });
                            } else if (dadosRecebidos.salas && dadosRecebidos.salas.length > 0) {
                                // Fallback: usar dados dos arrays principais
                                dadosRecebidos.salas.forEach(sala => {
                                    if (sala.datas && sala.datas.includes(data)) {
                                        const chave = `${sala.salaTitulo || ''}|${sala.salaNome || ''}`;
                                        if (!salasUnicas[chave]) {
                                            salasUnicas[chave] = {
                                                salaTitulo: sala.salaTitulo || '',
                                                salaNome: sala.salaNome || '',
                                                // Novos campos fixos - mapeamento do backend
                                                layout: sala.salaLayoutNovo || sala.layout || '',
                                                horario: sala.salaHorario || sala.horario || '',
                                                equipamento: sala.salaEquipamentoFornecedor || sala.equipamento || '',
                                                cenografia: sala.salaCenografiaFornecedor || sala.cenografia || '',
                                                observacao: sala.salaObservacaoNova || sala.observacao || '',
                                                // Campos antigos (compatibilidade)
                                                layoutMontagem: sala.salaLayout || sala.layoutMontagem || '',
                                                equipamentos: sala.salaEquipamentos || sala.equipamentos || '',
                                                observacoes: sala.salaObservacao || sala.observacoes || '',
                                                datas: []
                                            };
                                            // Carregar campos dinâmicos se existirem
                                            if (Array.isArray(sala.camposDinamicos) && sala.camposDinamicos.length > 0) {
                                                salasUnicas[chave].camposDinamicos = sala.camposDinamicos;
                                            }
                                        }
                                        if (!salasUnicas[chave].datas.includes(data)) {
                                            salasUnicas[chave].datas.push(data);
                                        }
                                    }
                                });
                            }

                            // Processar alimentação e bebidas
                            if (config.alimentacaoBebidas && Array.isArray(config.alimentacaoBebidas) && config.alimentacaoBebidas.length > 0) {
                                config.alimentacaoBebidas.forEach(ab => {
                                    const chave = `${ab.abNome || ''}|${ab.abLocal || ''}`;
                                    if (!absUnicas[chave]) {
                                        absUnicas[chave] = {
                                            abNome: ab.abNome || '',
                                            abLocal: ab.abLocal || '',
                                            valor: ab.valor || 0,
                                            quantidade: ab.quantidade || 1,
                                            composicao: ab.composicao || '',
                                            horario: ab.horario || '',
                                            local: ab.local || '',
                                            // Novos campos fixos - mapear do backend
                                            layout: ab.layoutMontagem || '',
                                            equipamento: ab.equipamentos || '',
                                            cenografia: ab.cenografia || '',
                                            observacao: ab.observacoes || '',
                                            datas: [],
                                            // Carregar camposDinamicos se vier do backend
                                            camposDinamicos: Array.isArray(ab.camposDinamicos) ? ab.camposDinamicos : []
                                        };
                                    } else {
                                        // Se já existe, atualizar os campos se necessário
                                        if (Array.isArray(ab.camposDinamicos) && ab.camposDinamicos.length > 0) {
                                            absUnicas[chave].camposDinamicos = ab.camposDinamicos;
                                        }
                                        // Atualizar novos campos se existirem
                                        if (ab.layoutMontagem) {
                                            absUnicas[chave].layout = ab.layoutMontagem;
                                        }
                                        if (ab.equipamentos) {
                                            absUnicas[chave].equipamento = ab.equipamentos;
                                        }
                                        if (ab.cenografia) {
                                            absUnicas[chave].cenografia = ab.cenografia;
                                        }
                                        if (ab.observacoes) {
                                            absUnicas[chave].observacao = ab.observacoes;
                                        }
                                        if (ab.horario) {
                                            absUnicas[chave].horario = ab.horario;
                                        }
                                    }
                                    absUnicas[chave].datas.push(data);
                                });
                            } else if (dadosRecebidos.abs && dadosRecebidos.abs.length > 0) {
                                // Fallback: usar dados dos arrays principais
                                dadosRecebidos.abs.forEach(ab => {
                                    if (ab.datas && ab.datas.includes(data)) {
                                        const chave = `${ab.abNome || ''}|${ab.abLocal || ''}`;
                                        if (!absUnicas[chave]) {
                                            absUnicas[chave] = {
                                                abNome: ab.abNome || '',
                                                abLocal: ab.abLocal || '',
                                                valor: parseFloat(ab.abValor) || 0,
                                                quantidade: ab.abQuantidade || 1,
                                                composicao: ab.abComposicao || '',
                                                horario: ab.abHorario || '',
                                                local: ab.abLocal || '',
                                                datas: []
                                            };
                                        }
                                        if (!absUnicas[chave].datas.includes(data)) {
                                            absUnicas[chave].datas.push(data);
                                        }
                                    }
                                });
                            }

                            // Processar eventos
                            if (config.eventos && Array.isArray(config.eventos)) {
                                config.eventos.forEach(evento => {
                                    const chave = `${evento.eventoNome || ''}|${evento.eventoLocal || ''}`;
                                    if (!eventosUnicos[chave]) {
                                        eventosUnicos[chave] = {
                                            eventoNome: evento.eventoNome || '',
                                            eventoLocal: evento.eventoLocal || '',
                                            // Novos campos fixos - mapear do backend
                                            layout: evento.layoutMontagem || '',
                                            horario: evento.horario || '',
                                            equipamento: evento.equipamentos || '',
                                            cenografia: evento.cenografia || '',
                                            observacao: evento.observacoes || '',
                                            datas: [],
                                            // Carregar camposDinamicos se vier do backend
                                            camposDinamicos: Array.isArray(evento.camposDinamicos) ? evento.camposDinamicos : []
                                        };
                                    } else {
                                        // Se já existe, atualizar os campos se necessário
                                        if (Array.isArray(evento.camposDinamicos) && evento.camposDinamicos.length > 0) {
                                            eventosUnicos[chave].camposDinamicos = evento.camposDinamicos;
                                        }
                                        // Atualizar novos campos se existirem
                                        if (evento.layoutMontagem) {
                                            eventosUnicos[chave].layout = evento.layoutMontagem;
                                        }
                                        if (evento.equipamentos) {
                                            eventosUnicos[chave].equipamento = evento.equipamentos;
                                        }
                                        if (evento.cenografia) {
                                            eventosUnicos[chave].cenografia = evento.cenografia;
                                        }
                                        if (evento.observacoes) {
                                            eventosUnicos[chave].observacao = evento.observacoes;
                                        }
                                        if (evento.horario) {
                                            eventosUnicos[chave].horario = evento.horario;
                                        }
                                    }
                                    eventosUnicos[chave].datas.push(data);
                                });
                            }

                            // Processar montagem eventos
                            if (config.montagemEventos && Array.isArray(config.montagemEventos)) {
                                config.montagemEventos.forEach(montagem => {
                                    const chave = `${montagem.montagemEventoNome || ''}|${montagem.montagemEventoLocal || ''}`;
                                    if (!montagemEventosUnicos[chave]) {
                                        montagemEventosUnicos[chave] = {
                                            montagemEventoNome: montagem.montagemEventoNome || '',
                                            montagemEventoLocal: montagem.montagemEventoLocal || '',
                                            datas: [],
                                            // Carregar camposDinamicos se vier do backend
                                            camposDinamicos: Array.isArray(montagem.camposDinamicos) ? montagem.camposDinamicos : [],
                                            // Carregar novos campos se vierem do backend
                                            layout: montagem.layoutMontagem || '',
                                            horario: montagem.horario || '',
                                            equipamento: montagem.equipamentos || '',
                                            cenografia: montagem.cenografia || '',
                                            observacao: montagem.observacoes || ''
                                        };
                                    } else {
                                        // Se já existe, garantir que camposDinamicos não seja sobrescrito se já houver
                                        if (Array.isArray(montagem.camposDinamicos) && montagem.camposDinamicos.length > 0) {
                                            montagemEventosUnicos[chave].camposDinamicos = montagem.camposDinamicos;
                                        }
                                        // Atualizar novos campos se existirem
                                        if (montagem.layoutMontagem) {
                                            montagemEventosUnicos[chave].layout = montagem.layoutMontagem;
                                        }
                                        if (montagem.equipamentos) {
                                            montagemEventosUnicos[chave].equipamento = montagem.equipamentos;
                                        }
                                        if (montagem.cenografia) {
                                            montagemEventosUnicos[chave].cenografia = montagem.cenografia;
                                        }
                                        if (montagem.observacoes) {
                                            montagemEventosUnicos[chave].observacao = montagem.observacoes;
                                        }
                                        if (montagem.horario) {
                                            montagemEventosUnicos[chave].horario = montagem.horario;
                                        }
                                    }
                                    montagemEventosUnicos[chave].datas.push(data);
                                });
                            }
                        });
                    }

                    // Converter para arrays e limpar datas duplicadas
                    const salasArray = Object.values(salasUnicas).map(sala => ({
                        ...sala,
                        datas: [...new Set(sala.datas)]
                    }));

                    const absArray = Object.values(absUnicas).map(ab => ({
                        ...ab,
                        datas: [...new Set(ab.datas)]
                    }));

                    const eventosArray = Object.values(eventosUnicos).map(evento => ({
                        ...evento,
                        datas: [...new Set(evento.datas)]
                    }));

                    const montagemEventosArray = Object.values(montagemEventosUnicos).map(montagem => ({
                        ...montagem,
                        datas: [...new Set(montagem.datas)]
                    }));

                    console.log('Salas processadas:', salasArray);
                    console.log('=== DEBUG NOVOS CAMPOS CARREGADOS ===');
                    salasArray.forEach((sala, index) => {
                        console.log(`Sala ${index + 1}:`, {
                            salaTitulo: sala.salaTitulo,
                            layout: sala.layout,
                            horario: sala.horario,
                            equipamento: sala.equipamento,
                            cenografia: sala.cenografia,
                            observacao: sala.observacao
                        });
                    });
                    absArray.forEach((ab, index) => {
                        console.log(`A&B ${index + 1}:`, {
                            abNome: ab.abNome,
                            layout: ab.layout,
                            horario: ab.horario,
                            equipamento: ab.equipamento,
                            cenografia: ab.cenografia,
                            observacao: ab.observacao
                        });
                    });
                    eventosArray.forEach((evento, index) => {
                        console.log(`Evento ${index + 1}:`, {
                            eventoNome: evento.eventoNome,
                            layout: evento.layout,
                            horario: evento.horario,
                            equipamento: evento.equipamento,
                            cenografia: evento.cenografia,
                            observacao: evento.observacao
                        });
                    });
                    montagemEventosArray.forEach((montagem, index) => {
                        console.log(`Montagem+Evento ${index + 1}:`, {
                            montagemEventoNome: montagem.montagemEventoNome,
                            layout: montagem.layout,
                            horario: montagem.horario,
                            equipamento: montagem.equipamento,
                            cenografia: montagem.cenografia,
                            observacao: montagem.observacao
                        });
                    });
                    console.log('======================================');
                    console.log('ABs processados:', absArray);
                    console.log('Eventos processados:', eventosArray);
                    console.log('Montagem eventos processados:', montagemEventosArray);

                    // Aplicar os dados processados
                    setSalas(salasArray);
                    setAbs(absArray);
                    setEventos(eventosArray);
                    setMontagemEventos(montagemEventosArray);

                    // Armazenar configurações por data
                    setConfiguracoesPorData(configPorData);
                } else {
                    // Fallback para dados diretos se não houver configurações por data
                    setSalas(dadosRecebidos.salas ?? []);
                    setAbs(dadosRecebidos.abs ?? []);
                    setEventos(dadosRecebidos.eventos ?? []);
                    setMontagemEventos(dadosRecebidos.montagemEventos ?? []);
                    setConfiguracoesPorData({});
                }

                // Processar valores acordados a partir do snapshot
                const valoresSnapshot = extrairValoresAcordadosDoSnapshot(dadosRecebidos);
                setValoresAcordados(valoresSnapshot);

                // start empty unless server provides values - criar IDs únicos
                const obsComIds = (dadosRecebidos.observacoesGerais ?? []).map((obs, index) => ({
                    id: index + 1,
                    titulo: typeof obs === 'object' ? (obs.titulo || '') : '',
                    texto: typeof obs === 'object' ? obs.texto : obs
                }));
                setObservacoesGerais(obsComIds);
                setNextObsId(obsComIds.length + 1);

                const nfComIds = (dadosRecebidos.informacoesNF ?? []).map((info, index) => ({
                    id: index + 1,
                    texto: typeof info === 'object' ? info.texto : info,
                    isFixo: typeof info === 'object' ? (info.isFixo || false) : false
                }));

                console.log('=== DEBUG: Dados NF do backend ===', dadosRecebidos.informacoesNF);
                console.log('=== DEBUG: NF processadas do backend ===', nfComIds);
                console.log('=== DEBUG: ordemServicoId ===', ordemServicoId);

                // Se há dados de NF vindos do backend, significa que estamos EDITANDO uma ordem existente
                if (dadosRecebidos.informacoesNF && dadosRecebidos.informacoesNF.length > 0) {
                    console.log('=== DEBUG: EDITANDO - Usando apenas dados do banco (dados existem) ===', nfComIds);
                    setInformacoesNF(nfComIds);
                    setNextNfId(Math.max(...nfComIds.map(item => item.id || 0)) + 1);
                } else {
                    // Se NÃO há dados de NF do backend, significa que estamos CRIANDO nova ordem
                    console.log('=== DEBUG: CRIANDO - Adicionando itens fixos (sem dados existentes) ===');
                    const itensFixosExistentes = itensFixosNF.map((texto, index) => ({
                        id: index + 1,
                        texto: texto,
                        isFixo: true
                    }));

                    console.log('=== DEBUG: Itens fixos criados ===', itensFixosExistentes);
                    setInformacoesNF(itensFixosExistentes);
                    setNextNfId(itensFixosNF.length + 1);
                }
                setIsLoading(false);
            }).catch(err => {
                console.error('Erro ao buscar dados no endpoint original:', err);
                if (err.response?.status === 404) {
                    // Tentar o endpoint Pack como fallback
                    console.log('Tentando endpoint Pack como fallback...');
                    api({
                        method: "get",
                        action: '/eventoOrdemServicoPack/' + idEvento,
                        token: token,
                    }).then(response => {
                        const dadosRecebidos = response.data.data;
                        console.log('Dados recebidos do endpoint Pack:', dadosRecebidos);
                        console.log('Estrutura completa da resposta Pack:', JSON.stringify(response.data, null, 2));

                        // Capturar o ID da ordem de serviço se existir
                        if (dadosRecebidos.ordemServico) {
                            console.log('Encontrado ordemServico no Pack:', dadosRecebidos.ordemServico);
                            setOrdemServicoId(dadosRecebidos.ordemServico);
                        } else if (dadosRecebidos.ordemId) {
                            console.log('Encontrado ordemId no Pack:', dadosRecebidos.ordemId);
                            setOrdemServicoId(dadosRecebidos.ordemId);
                        } else if (dadosRecebidos.id) {
                            console.log('Encontrado id no Pack:', dadosRecebidos.id);
                            setOrdemServicoId(dadosRecebidos.id);
                        } else {
                            console.log('Nenhum ID de ordem encontrado no Pack');
                            setOrdemServicoId(null);
                        }

                        // Capturar informações do evento para o header
                        if (dadosRecebidos.evento) {
                            setInformacoesEvento({
                                nome: dadosRecebidos.evento.nome || 'Evento sem nome',
                                id: dadosRecebidos.evento.id || idEvento
                            });
                        }

                        // Processar os dados normalmente - usar informacoesGerais primeiro
                        console.log('=== DEBUG Pack: Carregando dados de contato ===');
                        console.log('contato_nome do root (Pack):', dadosRecebidos.contato_nome);
                        console.log('contato_telefone do root (Pack):', dadosRecebidos.contato_telefone);

                        if (dadosRecebidos.informacoesGerais) {
                            setDados({
                                dataInicio: dadosRecebidos.informacoesGerais.dataInicio ? dadosRecebidos.informacoesGerais.dataInicio.split('T')[0] : '',
                                dataFim: dadosRecebidos.informacoesGerais.dataFim ? dadosRecebidos.informacoesGerais.dataFim.split('T')[0] : '',
                                checkin: dadosRecebidos.checkin || ''
                            });
                            // Carregar dados de contato - priorizar informacoesGerais, fallback para root
                            setContatoNome(dadosRecebidos.informacoesGerais.contatoNome || dadosRecebidos.contato_nome || '');
                            setContatoTelefone(dadosRecebidos.informacoesGerais.contatoTelefone || dadosRecebidos.contato_telefone || '');
                        } else if (dadosRecebidos.evento) {
                            setDados({
                                dataInicio: dadosRecebidos.evento.data ? dadosRecebidos.evento.data.split(' ')[0] : '',
                                dataFim: dadosRecebidos.evento.dataFim ? dadosRecebidos.evento.dataFim.split(' ')[0] : '',
                                checkin: dadosRecebidos.checkin || ''
                            });
                            // Carregar dados de contato
                            setContatoNome(dadosRecebidos.contato_nome || '');
                            setContatoTelefone(dadosRecebidos.contato_telefone || '');
                        } else {
                            setDados(dadosRecebidos);
                            // Carregar dados de contato
                            setContatoNome(dadosRecebidos.contato_nome || '');
                            setContatoTelefone(dadosRecebidos.contato_telefone || '');
                        }

                        // Log final dos dados carregados (Pack)
                        console.log('=== DEBUG Pack: Dados de contato carregados ===');
                        console.log('contatoNome final (Pack):', dadosRecebidos.informacoesGerais?.contatoNome || dadosRecebidos.contato_nome);
                        console.log('contatoTelefone final (Pack):', dadosRecebidos.informacoesGerais?.contatoTelefone || dadosRecebidos.contato_telefone);

                        console.log('Salas recebidas do endpoint Pack:', dadosRecebidos.salas);
                        if (dadosRecebidos.salas && dadosRecebidos.salas.length > 0) {
                            console.log('Primeira sala do Pack:', dadosRecebidos.salas[0]);
                            console.log('Campos da primeira sala do Pack:', Object.keys(dadosRecebidos.salas[0]));
                        }
                        setSalas(dadosRecebidos.salas ?? []);

                        console.log('AB recebidos do endpoint Pack:', dadosRecebidos.abs);
                        if (dadosRecebidos.abs && dadosRecebidos.abs.length > 0) {
                            console.log('Primeiro AB do Pack:', dadosRecebidos.abs[0]);
                            console.log('Campos do primeiro AB do Pack:', Object.keys(dadosRecebidos.abs[0]));
                        }
                        setAbs(dadosRecebidos.abs ?? []);

                        console.log('Eventos recebidos do endpoint Pack:', dadosRecebidos.eventos);
                        if (dadosRecebidos.eventos && dadosRecebidos.eventos.length > 0) {
                            console.log('Primeiro evento do Pack:', dadosRecebidos.eventos[0]);
                            console.log('Campos do primeiro evento do Pack:', Object.keys(dadosRecebidos.eventos[0]));
                        }
                        setEventos(dadosRecebidos.eventos ?? []);

                        console.log('Montagem eventos recebidos do endpoint Pack:', dadosRecebidos.montagemEventos);
                        if (dadosRecebidos.montagemEventos && dadosRecebidos.montagemEventos.length > 0) {
                            console.log('Primeiro montagem evento do Pack:', dadosRecebidos.montagemEventos[0]);
                            console.log('Campos do primeiro montagem evento do Pack:', Object.keys(dadosRecebidos.montagemEventos[0]));
                        }
                        setMontagemEventos(dadosRecebidos.montagemEventos ?? []);
                        // Processar valores acordados a partir do snapshot (Pack fallback)
                        const valoresSnapshotPack = extrairValoresAcordadosDoSnapshot(dadosRecebidos);
                        setValoresAcordados(valoresSnapshotPack);

                        // Converter arrays de strings para objetos com IDs
                        const obsComIds = (dadosRecebidos.observacoesGerais ?? []).map((obs, index) => ({
                            id: index + 1,
                            titulo: typeof obs === 'object' ? (obs.titulo || '') : '',
                            texto: typeof obs === 'object' ? obs.texto : obs
                        }));
                        setObservacoesGerais(obsComIds);
                        setNextObsId(obsComIds.length + 1);

                        const nfComIds = (dadosRecebidos.informacoesNF ?? []).map((info, index) => ({
                            id: index + 1,
                            texto: typeof info === 'object' ? info.texto : info,
                            isFixo: typeof info === 'object' ? (info.isFixo || false) : false
                        }));

                        console.log('=== DEBUG: Dados NF do backend (2º local) ===', dadosRecebidos.informacoesNF);
                        console.log('=== DEBUG: NF processadas do backend (2º local) ===', nfComIds);
                        console.log('=== DEBUG: ordemServicoId (2º local) ===', ordemServicoId);

                        // Se há dados de NF vindos do backend, significa que estamos EDITANDO uma ordem existente
                        if (dadosRecebidos.informacoesNF && dadosRecebidos.informacoesNF.length > 0) {
                            console.log('=== DEBUG: EDITANDO (2º local) - Usando apenas dados do banco (dados existem) ===', nfComIds);
                            setInformacoesNF(nfComIds);
                            setNextNfId(Math.max(...nfComIds.map(item => item.id || 0)) + 1);
                        } else {
                            // Se NÃO há dados de NF do backend, significa que estamos CRIANDO nova ordem
                            console.log('=== DEBUG: CRIANDO (2º local) - Adicionando itens fixos (sem dados existentes) ===');
                            const itensFixosExistentes = itensFixosNF.map((texto, index) => ({
                                id: index + 1,
                                texto: texto,
                                isFixo: true
                            }));

                            console.log('=== DEBUG: Itens fixos criados (2º local) ===', itensFixosExistentes);
                            setInformacoesNF(itensFixosExistentes);
                            setNextNfId(itensFixosNF.length + 1);
                        }
                    }).catch(err2 => {
                        console.error('Erro também no endpoint Pack:', err2);
                        console.log('Ordem de serviço não encontrada em nenhum endpoint - criando nova');
                        setOrdemServicoId(null);
                    }).finally(() => { setIsLoading(false); });
                } else {
                    console.error('Erro ao carregar dados:', err.response?.data?.error ?? err.message);
                    setIsLoading(false);
                }
            });
        } catch (err) {
            console.error('Erro ao buscar dados:', err);
        }
    };

    const buscarFornecedores = async () => {
        try {
            console.log('Buscando fornecedores...');
            const response = await api({
                method: "get",
                action: '/participante?tipoCadastro=fornecedor',
                token: token,
            });

            if (response.data && response.data.data) {
                const fornecedores = response.data.data.map(fornecedor => ({
                    id: fornecedor.id,
                    nome: fornecedor.nome || fornecedor.razaoSocial || `Fornecedor ${fornecedor.id}`
                }));

                console.log('Fornecedores carregados:', fornecedores.length);
                setFornecedoresEquipamento(fornecedores);
                setFornecedoresCenografia(fornecedores);
            }
        } catch (error) {
            console.error('Erro ao buscar fornecedores:', error);
        }
    };

    useEffect(() => {
        buscar();
        buscarFornecedores();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Efeito para migrar dados quando o período do evento mudar
    useEffect(() => {
        if (!dados.dataInicio || !dados.dataFim) return;

        const novasDatas = getDateRange(dados.dataInicio, dados.dataFim);
        console.log('=== MIGRAÇÃO DE DATAS ===');
        console.log('Novo período:', novasDatas);

        // Coletar todas as datas antigas que têm dados
        const datasAntigasComDados = new Set();
        [...salas, ...abs, ...eventos, ...montagemEventos].forEach(item => {
            if (item.datas && Array.isArray(item.datas)) {
                item.datas.forEach(data => datasAntigasComDados.add(data));
            }
        });

        console.log('Datas antigas com dados:', Array.from(datasAntigasComDados));

        // Se houver dados em datas que não estão no novo período, migrar
        const datasForaDoPeriodo = Array.from(datasAntigasComDados).filter(data => !novasDatas.includes(data));

        if (datasForaDoPeriodo.length > 0) {
            console.log('Dados encontrados fora do novo período:', datasForaDoPeriodo);
            console.log('Migrando dados para o novo período...');

            // Função para migrar datas de um array de itens
            const migrarDatasDoArray = (array, setArray, nomeArray) => {
                const arrayAtualizado = array.map(item => {
                    if (item.datas && Array.isArray(item.datas)) {
                        const datasNoPeriodo = item.datas.filter(data => novasDatas.includes(data));

                        // Se nenhuma data do item está no novo período, migrar para a primeira data
                        if (datasNoPeriodo.length === 0) {
                            console.log(`Migrando ${nomeArray}:`, item, 'para primeira data do período:', novasDatas[0]);
                            return { ...item, datas: [novasDatas[0]] };
                        }

                        // Se algumas datas estão fora, manter apenas as que estão no período
                        if (datasNoPeriodo.length !== item.datas.length) {
                            console.log(`Ajustando datas de ${nomeArray}:`, item, 'para:', datasNoPeriodo);
                            return { ...item, datas: datasNoPeriodo };
                        }
                    }
                    return item;
                });

                if (JSON.stringify(arrayAtualizado) !== JSON.stringify(array)) {
                    console.log(`Aplicando migração em ${nomeArray}`);
                    setArray(arrayAtualizado);
                }
            };

            // Migrar todos os arrays
            migrarDatasDoArray(salas, setSalas, 'salas');
            migrarDatasDoArray(abs, setAbs, 'abs');
            migrarDatasDoArray(eventos, setEventos, 'eventos');
            migrarDatasDoArray(montagemEventos, setMontagemEventos, 'montagemEventos');
        }

        console.log('=========================');
    }, [dados.dataInicio, dados.dataFim, salas, abs, eventos, montagemEventos, getDateRange]); // Executa quando as datas do período mudarem

    // Abas dinâmicas: SEMPRE baseadas no período do evento
    const datasConfiguradas = useMemo(() => {
        console.log('=== CALCULANDO ABAS DE DATAS ===');
        console.log('dados.dataInicio:', dados.dataInicio);
        console.log('dados.dataFim:', dados.dataFim);

        // Só criar abas de data se ambos início e fim estiverem definidos
        if (dados.dataInicio && dados.dataFim) {
            const rangeDatas = getDateRange(dados.dataInicio, dados.dataFim);
            console.log('Abas criadas baseadas no período do evento:', rangeDatas);
            console.log('==============================');
            return rangeDatas;
        }

        // Se não há período definido, não retorna nenhuma aba de data
        console.log('Sem período definido, nenhuma aba de data será criada');
        return [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configuracoesPorData, salas, abs, eventos, montagemEventos, dados.dataInicio, dados.dataFim, getDateRange]);
    
    const abas = [
        { id: 'valores-acordados', nome: 'Valores Acordados', icon: <FaDollarSign /> },
        ...datasConfiguradas.map(dt => {
            // Verificar se esta data tem dados configurados
            const temSalas = salas.some(s => (s?.datas ?? []).includes(dt));
            const temAbs = abs.some(a => (a?.datas ?? []).includes(dt));
            const temEventos = eventos.some(e => (e?.datas ?? []).includes(dt));
            const temMontagem = montagemEventos.some(m => (m?.datas ?? []).includes(dt));
            const temDados = temSalas || temAbs || temEventos || temMontagem;

            return {
                id: `dia-${dt}`,
                nome: formatDateBR(dt),
                icon: <FaCalendarAlt />,
                temDados: temDados
            };
        }),
        { id: 'observacoes', nome: 'Observações', icon: <FaStickyNote /> },
        { id: 'nf', nome: 'Nota Fiscal', icon: <FaFileInvoiceDollar /> }
    ];

    const renderValoresAcordados = () => {
        const itensPorCategoria = valoresAcordados.reduce((grupos, item) => {
            const categoria = item.categoria || 'Outros';
            if (!grupos[categoria]) grupos[categoria] = [];
            grupos[categoria].push(item);
            return grupos;
        }, {});

        const categorias = ['Hospedagem', 'Salas', 'A&B Evento', 'Equipamentos', 'Outros'];

        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Valores Acordados</span>
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                        onClick={() => {
                            const categorias = ['Hospedagem', 'Salas', 'A&B Evento', 'Equipamentos', 'Outros'];
                            const categoriasExistentes = [...new Set(valoresAcordados.map(item => item.categoria))];
                            let novaCategoria = categorias.find(cat => !categoriasExistentes.includes(cat)) || 'Hospedagem';
                            const novoId = valoresAcordados.length > 0
                                ? Math.max(...valoresAcordados.map(item => item.id || 0)) + 1
                                : 1;
                            setValoresAcordados([...valoresAcordados, {
                                id: novoId, categoria: novaCategoria, titulo: '', item: '',
                                valor: '0', imposto: '0', txServico: '0', observacao: ''
                            }]);
                        }}
                    >
                        <FaPlus size={12} style={{ marginRight: 6 }} /> Adicionar Ambiente
                    </button>
                </div>
                <div style={{ padding: '16px' }}>
                    {valoresAcordados.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '32px', color: 'var(--fin-mt)' }}>
                            <FaDollarSign size={48} style={{ marginBottom: 12 }} />
                            <p>Nenhum valor acordado cadastrado</p>
                        </div>
                    )}

                    {categorias.map(categoria => {
                        const itensCategoria = itensPorCategoria[categoria] || [];
                        if (itensCategoria.length === 0) return null;

                        return (
                            <div key={categoria} style={{ marginBottom: 12 }}>
                                <div className="fin-pp__cphead" style={{ marginBottom: 8 }}>
                                    <span className={`fin-pp__pill ${getCategoriaColor(categoria)}`}>{categoria}</span>
                                    <span style={{ color: 'var(--fin-mt)', fontSize: 13 }}>
                                        {itensCategoria.length} {itensCategoria.length === 1 ? 'item' : 'itens'}
                                    </span>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                                        onClick={() => {
                                            const novoId = valoresAcordados.length > 0
                                                ? Math.max(...valoresAcordados.map(item => item.id || 0)) + 1
                                                : 1;
                                            setValoresAcordados([...valoresAcordados, {
                                                id: novoId, categoria: categoria, titulo: '', item: '',
                                                valor: '0', imposto: '0', txServico: '0', observacao: ''
                                            }]);
                                        }}
                                    >
                                        <FaPlus size={12} style={{ marginRight: 4 }} /> Adicionar Item
                                    </button>
                                </div>

                                {itensCategoria.map((item, indexLocal) => {
                                    const indexGlobal = valoresAcordados.findIndex(v => v.id === item.id);

                                    return (
                                        <div key={item.id} className="fin-pp__card" style={{ marginLeft: 12, marginBottom: 10 }}>
                                            <div className="fin-pp__cphead">
                                                <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>
                                                    Item {indexLocal + 1}
                                                </span>
                                                <select
                                                    className="fin-pp__select"
                                                    style={{ width: 'auto', height: 34 }}
                                                    value={item.categoria}
                                                    onChange={(e) => {
                                                        const novosValores = [...valoresAcordados];
                                                        novosValores[indexGlobal].categoria = e.target.value;
                                                        setValoresAcordados(novosValores);
                                                    }}
                                                >
                                                    <option value="Hospedagem">Hospedagem</option>
                                                    <option value="Salas">Salas</option>
                                                    <option value="A&B Evento">A&B Evento</option>
                                                    <option value="Equipamentos">Equipamentos</option>
                                                    <option value="Outros">Outros</option>
                                                </select>
                                                <button
                                                    type="button"
                                                    className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger"
                                                    onClick={() => {
                                                        setValoresAcordados(valoresAcordados.filter(i => i.id !== item.id));
                                                    }}
                                                >
                                                    <FaTrash size={13} />
                                                </button>
                                            </div>
                                            <div style={{ padding: '12px' }}>
                                                <div className="fin-pp__filters">
                                                    <div className="fin-pp__field" style={{ flex: '1 1 200px' }}>
                                                        <span className="fin-pp__label">Título do Item</span>
                                                        <input
                                                            type="text"
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={item.titulo || ''}
                                                            onChange={(e) => {
                                                                const novosValores = [...valoresAcordados];
                                                                novosValores[indexGlobal].titulo = e.target.value;
                                                                setValoresAcordados(novosValores);
                                                            }}
                                                            placeholder="Digite o título para este item..."
                                                        />
                                                    </div>
                                                    <div className="fin-pp__field">
                                                        <span className="fin-pp__label">Valor Base (R$)</span>
                                                        <input
                                                            type="text"
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={item.valor}
                                                            onChange={(e) => {
                                                                const valorSanitizado = sanitizeNumber(e.target.value);
                                                                const novosValores = [...valoresAcordados];
                                                                novosValores[indexGlobal].valor = valorSanitizado;
                                                                setValoresAcordados(novosValores);
                                                            }}
                                                            placeholder="ex: 1500,00"
                                                        />
                                                    </div>
                                                    <div className="fin-pp__field">
                                                        <span className="fin-pp__label">Imposto (%)</span>
                                                        <input
                                                            type="text"
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={item.imposto}
                                                            onChange={(e) => {
                                                                const valorSanitizado = sanitizeNumber(e.target.value);
                                                                const novosValores = [...valoresAcordados];
                                                                novosValores[indexGlobal].imposto = valorSanitizado;
                                                                setValoresAcordados(novosValores);
                                                            }}
                                                            placeholder="ex: 3,75"
                                                        />
                                                    </div>
                                                    <div className="fin-pp__field">
                                                        <span className="fin-pp__label">Taxa Serviço (%)</span>
                                                        <input
                                                            type="text"
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={item.txServico}
                                                            onChange={(e) => {
                                                                const valorSanitizado = sanitizeNumber(e.target.value);
                                                                const novosValores = [...valoresAcordados];
                                                                novosValores[indexGlobal].txServico = valorSanitizado;
                                                                setValoresAcordados(novosValores);
                                                            }}
                                                            placeholder="ex: 5,25"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="fin-pp__field" style={{ marginTop: 10 }}>
                                                    <span className="fin-pp__label">Observações</span>
                                                    <textarea
                                                        className="fin-pp__input"
                                                        style={{ height: 'auto', padding: '10px 14px' }}
                                                        value={item.observacao}
                                                        onChange={(e) => {
                                                            const novosValores = [...valoresAcordados];
                                                            novosValores[indexGlobal].observacao = e.target.value;
                                                            setValoresAcordados(novosValores);
                                                        }}
                                                        placeholder="Digite observações adicionais sobre este item..."
                                                    />
                                                </div>
                                                <div style={{
                                                    background: 'var(--fin-acw)', borderLeft: '3px solid var(--fin-ac)',
                                                    borderRadius: 6, padding: '10px 14px', marginTop: 10,
                                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                                }}>
                                                    <span style={{ fontWeight: 600, color: 'var(--fin-tx)' }}>Total do item (com impostos):</span>
                                                    <span style={{ fontWeight: 700, color: 'var(--fin-ok)', fontSize: 16 }}>
                                                        {(() => {
                                                            const valor = parseFloat(item.valor) || 0;
                                                            const impostoPercent = (parseFloat(item.imposto) || 0) / 100;
                                                            const txServicoPercent = (parseFloat(item.txServico) || 0) / 100;
                                                            const total = valor + (valor * impostoPercent) + (valor * txServicoPercent);
                                                            return formatCurrency(total);
                                                        })()}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}

                    {valoresAcordados.length > 0 && (
                        <div className="fin-pp__card" style={{ marginTop: 16 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px' }}>
                                <strong style={{ color: 'var(--fin-tx)' }}>Valor Total do Evento:</strong>
                                <span style={{ fontSize: 20, fontWeight: 700, color: 'var(--fin-ac)' }}>{formatCurrency(calcularValorTotal())}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderSalas = (dateFilter) => {
        const renderSalaCard = (sala, index) => {
            if (!sala.camposDinamicos) sala.camposDinamicos = [];
            return (
                <div key={`sala-${index}-${sala.sala_id || ''}`} className="fin-pp__card" style={{ marginBottom: 10 }}>
                    <div className="fin-pp__cphead">
                        <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>Configuração {index + 1}</span>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                            const novas = [...salas];
                            novas.splice(index, 1);
                            setSalas(novas);
                        }}><FaTrash size={13} /></button>
                    </div>
                    <div style={{ padding: 12 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Nome da Sala</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={sala.salaNome || ''} onChange={(e) => {
                                        const novas = [...salas]; novas[index].salaNome = e.target.value; setSalas(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Tipo de Atividade</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={sala.salaTitulo || ''} onChange={(e) => {
                                        const novas = [...salas]; novas[index].salaTitulo = e.target.value; setSalas(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Layout</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={sala.layout || ''} onChange={(e) => {
                                        const novas = [...salas]; novas[index].layout = e.target.value; setSalas(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Horário</span>
                                <input type="time" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={sala.horario || ''} onChange={(e) => {
                                        const novas = [...salas]; novas[index].horario = e.target.value; setSalas(novas);
                                    }} />
                            </div>
                        </div>
                        <div className="fin-pp__filters" style={{ marginTop: 8 }}>
                            <SelectSimples value={sala.equipamento || ''} onChange={(value) => {
                                const novas = [...salas]; novas[index].equipamento = value; setSalas(novas);
                            }} fornecedores={fornecedoresEquipamento} placeholder="Selecione um fornecedor de equipamento"
                                label="Equipamento" salaIndex={index} tipo="equipamento" />
                            <SelectSimples value={sala.cenografia || ''} onChange={(value) => {
                                const novas = [...salas]; novas[index].cenografia = value; setSalas(novas);
                            }} fornecedores={fornecedoresCenografia} placeholder="Selecione um fornecedor de cenografia"
                                label="Cenografia" salaIndex={index} tipo="cenografia" />
                        </div>
                        <div className="fin-pp__field" style={{ marginTop: 8 }}>
                            <span className="fin-pp__label">Observação</span>
                            <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px' }}
                                value={sala.observacao || ''} onChange={(e) => {
                                    const novas = [...salas]; novas[index].observacao = e.target.value; setSalas(novas);
                                }} />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fin-tx)' }}>Campos Dinâmicos</span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => {
                                    const novas = [...salas]; novas[index].camposDinamicos.push({ key: '', value: '' }); setSalas(novas);
                                }}><FaPlus size={11} style={{ marginRight: 4 }} /> Adicionar campo</button>
                            </div>
                            {sala.camposDinamicos.length === 0 && (
                                <span style={{ fontSize: 13, color: 'var(--fin-mt)' }}>Nenhum campo adicionado.</span>
                            )}
                            {sala.camposDinamicos.map((campo, i) => (
                                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Chave" value={campo.key} onChange={e => {
                                            const novas = [...salas]; novas[index].camposDinamicos[i].key = e.target.value; setSalas(novas);
                                        }} />
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Valor" value={campo.value} onChange={e => {
                                            const novas = [...salas]; novas[index].camposDinamicos[i].value = e.target.value; setSalas(novas);
                                        }} />
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                        const novas = [...salas]; novas[index].camposDinamicos.splice(i, 1); setSalas(novas);
                                    }}><FaTrash size={13} /></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        };

        if (dateFilter) {
            return (
                <div>
                    {salas.map((sala, index) => {
                        if (!((sala?.datas ?? []).includes(dateFilter))) return null;
                        return renderSalaCard(sala, index);
                    })}
                </div>
            );
        }
        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Gestão de Salas</span>
                </div>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl">
                        <thead>
                            <tr>
                                <th style={{ width: 44 }}></th>
                                <th>Nome</th>
                                <th>Título</th>
                            </tr>
                        </thead>
                        <tbody>
                            {salas.length === 0 && (
                                <tr><td colSpan={3} className="fin-pp__empty">Nenhuma sala cadastrada</td></tr>
                            )}
                            {salas.map((sala, index) => (
                                <tr key={`sala-table-${index}-${sala.sala_id || ''}`}>
                                    <td>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                            const novasSalas = [...salas]; novasSalas.splice(index, 1); setSalas(novasSalas);
                                        }}><FaTrash size={13} /></button>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={sala.salaNome} onChange={(e) => {
                                                    const novas = [...salas]; novas[index].salaNome = e.target.value; setSalas(novas);
                                                }} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={sala.salaTitulo} onChange={(e) => {
                                                    const novas = [...salas]; novas[index].salaTitulo = e.target.value; setSalas(novas);
                                                }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderAB = (dateFilter) => {
        const renderAbCard = (ab, index) => {
            if (!ab.camposDinamicos) ab.camposDinamicos = [];
            return (
                <div key={`ab-${index}-${ab.tipoAlimentacao || ''}`} className="fin-pp__card" style={{ marginBottom: 10 }}>
                    <div className="fin-pp__cphead">
                        <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>Configuração {index + 1}</span>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                            const novas = [...abs]; novas.splice(index, 1); setAbs(novas);
                        }}><FaTrash size={13} /></button>
                    </div>
                    <div style={{ padding: 12 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Nome da Sala</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={ab.abNome || ''} onChange={(e) => {
                                        const novas = [...abs]; novas[index].abNome = e.target.value; setAbs(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Tipo de Atividade</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={ab.abLocal || ''} onChange={(e) => {
                                        const novas = [...abs]; novas[index].abLocal = e.target.value; setAbs(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Layout</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={ab.layout || ''} onChange={(e) => {
                                        const novas = [...abs]; novas[index].layout = e.target.value; setAbs(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Horário</span>
                                <input type="time" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={ab.horario || ''} onChange={(e) => {
                                        const novas = [...abs]; novas[index].horario = e.target.value; setAbs(novas);
                                    }} />
                            </div>
                        </div>
                        <div className="fin-pp__filters" style={{ marginTop: 8 }}>
                            <SelectSimples value={ab.equipamento || ''} onChange={(value) => {
                                const novas = [...abs]; novas[index].equipamento = value; setAbs(novas);
                            }} fornecedores={fornecedoresEquipamento} placeholder="Selecione um fornecedor de equipamento"
                                label="Equipamento" salaIndex={index} tipo="equipamento" />
                            <SelectSimples value={ab.cenografia || ''} onChange={(value) => {
                                const novas = [...abs]; novas[index].cenografia = value; setAbs(novas);
                            }} fornecedores={fornecedoresCenografia} placeholder="Selecione um fornecedor de cenografia"
                                label="Cenografia" salaIndex={index} tipo="cenografia" />
                        </div>
                        <div className="fin-pp__field" style={{ marginTop: 8 }}>
                            <span className="fin-pp__label">Observação</span>
                            <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px' }}
                                value={ab.observacao || ''} onChange={(e) => {
                                    const novas = [...abs]; novas[index].observacao = e.target.value; setAbs(novas);
                                }} />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fin-tx)' }}>Campos Dinâmicos</span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => {
                                    const novas = [...abs]; novas[index].camposDinamicos.push({ key: '', value: '' }); setAbs(novas);
                                }}><FaPlus size={11} style={{ marginRight: 4 }} /> Adicionar campo</button>
                            </div>
                            {ab.camposDinamicos.length === 0 && (
                                <span style={{ fontSize: 13, color: 'var(--fin-mt)' }}>Nenhum campo adicionado.</span>
                            )}
                            {ab.camposDinamicos.map((campo, i) => (
                                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Chave" value={campo.key} onChange={e => {
                                            const novas = [...abs]; novas[index].camposDinamicos[i].key = e.target.value; setAbs(novas);
                                        }} />
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Valor" value={campo.value} onChange={e => {
                                            const novas = [...abs]; novas[index].camposDinamicos[i].value = e.target.value; setAbs(novas);
                                        }} />
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                        const novas = [...abs]; novas[index].camposDinamicos.splice(i, 1); setAbs(novas);
                                    }}><FaTrash size={13} /></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        };

        if (dateFilter) {
            return (
                <div>
                    {abs.map((ab, index) => {
                        if (!((ab?.datas ?? []).includes(dateFilter))) return null;
                        return renderAbCard(ab, index);
                    })}
                </div>
            );
        }
        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Alimentos &amp; Bebidas</span>
                </div>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl">
                        <thead>
                            <tr>
                                <th style={{ width: 44 }}></th>
                                <th>Nome</th>
                                <th>Local</th>
                            </tr>
                        </thead>
                        <tbody>
                            {abs.length === 0 && (
                                <tr><td colSpan={3} className="fin-pp__empty">Nenhum item cadastrado</td></tr>
                            )}
                            {abs.map((ab, index) => (
                                <tr key={`ab-table-${index}`}>
                                    <td>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                            const novas = [...abs]; novas.splice(index, 1); setAbs(novas);
                                        }}><FaTrash size={13} /></button>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={ab.abNome} onChange={(e) => {
                                                    const novas = [...abs]; novas[index].abNome = e.target.value; setAbs(novas);
                                                }} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={ab.abLocal} onChange={(e) => {
                                                    const novas = [...abs]; novas[index].abLocal = e.target.value; setAbs(novas);
                                                }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderEventos = (dateFilter) => {
        const renderEventoCard = (evento, index) => {
            if (!evento.camposDinamicos) evento.camposDinamicos = [];
            return (
                <div key={`evento-${index}-${evento.evento_id || ''}`} className="fin-pp__card" style={{ marginBottom: 10 }}>
                    <div className="fin-pp__cphead">
                        <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>Configuração {index + 1}</span>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                            const novas = [...eventos]; novas.splice(index, 1); setEventos(novas);
                        }}><FaTrash size={13} /></button>
                    </div>
                    <div style={{ padding: 12 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Nome da Sala</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={evento.eventoNome || ''} onChange={(e) => {
                                        const novas = [...eventos]; novas[index].eventoNome = e.target.value; setEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Tipo de Atividade</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={evento.eventoLocal || ''} onChange={(e) => {
                                        const novas = [...eventos]; novas[index].eventoLocal = e.target.value; setEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Layout</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={evento.layout || ''} onChange={(e) => {
                                        const novas = [...eventos]; novas[index].layout = e.target.value; setEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Horário</span>
                                <input type="time" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={evento.horario || ''} onChange={(e) => {
                                        const novas = [...eventos]; novas[index].horario = e.target.value; setEventos(novas);
                                    }} />
                            </div>
                        </div>
                        <div className="fin-pp__filters" style={{ marginTop: 8 }}>
                            <SelectSimples value={evento.equipamento || ''} onChange={(value) => {
                                const novas = [...eventos]; novas[index].equipamento = value; setEventos(novas);
                            }} fornecedores={fornecedoresEquipamento} placeholder="Selecione um fornecedor de equipamento"
                                label="Equipamento" salaIndex={index} tipo="equipamento" />
                            <SelectSimples value={evento.cenografia || ''} onChange={(value) => {
                                const novas = [...eventos]; novas[index].cenografia = value; setEventos(novas);
                            }} fornecedores={fornecedoresCenografia} placeholder="Selecione um fornecedor de cenografia"
                                label="Cenografia" salaIndex={index} tipo="cenografia" />
                        </div>
                        <div className="fin-pp__field" style={{ marginTop: 8 }}>
                            <span className="fin-pp__label">Observação</span>
                            <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px' }}
                                value={evento.observacao || ''} onChange={(e) => {
                                    const novas = [...eventos]; novas[index].observacao = e.target.value; setEventos(novas);
                                }} />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fin-tx)' }}>Campos Dinâmicos</span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => {
                                    const novas = [...eventos]; novas[index].camposDinamicos.push({ key: '', value: '' }); setEventos(novas);
                                }}><FaPlus size={11} style={{ marginRight: 4 }} /> Adicionar campo</button>
                            </div>
                            {evento.camposDinamicos.length === 0 && (
                                <span style={{ fontSize: 13, color: 'var(--fin-mt)' }}>Nenhum campo adicionado.</span>
                            )}
                            {evento.camposDinamicos.map((campo, i) => (
                                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Chave" value={campo.key} onChange={e => {
                                            const novas = [...eventos]; novas[index].camposDinamicos[i].key = e.target.value; setEventos(novas);
                                        }} />
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Valor" value={campo.value} onChange={e => {
                                            const novas = [...eventos]; novas[index].camposDinamicos[i].value = e.target.value; setEventos(novas);
                                        }} />
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                        const novas = [...eventos]; novas[index].camposDinamicos.splice(i, 1); setEventos(novas);
                                    }}><FaTrash size={13} /></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        };

        if (dateFilter) {
            return (
                <div>
                    {eventos.map((evento, index) => {
                        if (!((evento?.datas ?? []).includes(dateFilter))) return null;
                        return renderEventoCard(evento, index);
                    })}
                </div>
            );
        }
        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Eventos</span>
                </div>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl">
                        <thead>
                            <tr>
                                <th style={{ width: 44 }}></th>
                                <th>Nome</th>
                                <th>Local</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventos.length === 0 && (
                                <tr><td colSpan={3} className="fin-pp__empty">Nenhum evento cadastrado</td></tr>
                            )}
                            {eventos.map((evento, index) => (
                                <tr key={`evento-table-${index}`}>
                                    <td>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                            const novas = [...eventos]; novas.splice(index, 1); setEventos(novas);
                                        }}><FaTrash size={13} /></button>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={evento.eventoNome} onChange={(e) => {
                                                    const novas = [...eventos]; novas[index].eventoNome = e.target.value; setEventos(novas);
                                                }} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={evento.eventoLocal} onChange={(e) => {
                                                    const novas = [...eventos]; novas[index].eventoLocal = e.target.value; setEventos(novas);
                                                }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderMontagemEventos = (dateFilter) => {
        const renderMontagemCard = (montagemEvento, index) => {
            if (!montagemEvento.camposDinamicos) montagemEvento.camposDinamicos = [];
            return (
                <div key={`montagem-${index}-${montagemEvento.montagem_evento_id || ''}`} className="fin-pp__card" style={{ marginBottom: 10 }}>
                    <div className="fin-pp__cphead">
                        <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>Configuração {index + 1}</span>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                            const novas = [...montagemEventos]; novas.splice(index, 1); setMontagemEventos(novas);
                        }}><FaTrash size={13} /></button>
                    </div>
                    <div style={{ padding: 12 }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Nome da Sala</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={montagemEvento.montagemEventoNome || ''} onChange={(e) => {
                                        const novas = [...montagemEventos]; novas[index].montagemEventoNome = e.target.value; setMontagemEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Tipo de Atividade</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={montagemEvento.montagemEventoLocal || ''} onChange={(e) => {
                                        const novas = [...montagemEventos]; novas[index].montagemEventoLocal = e.target.value; setMontagemEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Layout</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={montagemEvento.layout || ''} onChange={(e) => {
                                        const novas = [...montagemEventos]; novas[index].layout = e.target.value; setMontagemEventos(novas);
                                    }} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Horário</span>
                                <input type="time" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={montagemEvento.horario || ''} onChange={(e) => {
                                        const novas = [...montagemEventos]; novas[index].horario = e.target.value; setMontagemEventos(novas);
                                    }} />
                            </div>
                        </div>
                        <div className="fin-pp__filters" style={{ marginTop: 8 }}>
                            <SelectSimples value={montagemEvento.equipamento || ''} onChange={(value) => {
                                const novas = [...montagemEventos]; novas[index].equipamento = value; setMontagemEventos(novas);
                            }} fornecedores={fornecedoresEquipamento} placeholder="Selecione um fornecedor de equipamento"
                                label="Equipamento" salaIndex={index} tipo="equipamento" />
                            <SelectSimples value={montagemEvento.cenografia || ''} onChange={(value) => {
                                const novas = [...montagemEventos]; novas[index].cenografia = value; setMontagemEventos(novas);
                            }} fornecedores={fornecedoresCenografia} placeholder="Selecione um fornecedor de cenografia"
                                label="Cenografia" salaIndex={index} tipo="cenografia" />
                        </div>
                        <div className="fin-pp__field" style={{ marginTop: 8 }}>
                            <span className="fin-pp__label">Observação</span>
                            <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px' }}
                                value={montagemEvento.observacao || ''} onChange={(e) => {
                                    const novas = [...montagemEventos]; novas[index].observacao = e.target.value; setMontagemEventos(novas);
                                }} />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fin-tx)' }}>Campos Dinâmicos</span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => {
                                    const novas = [...montagemEventos]; novas[index].camposDinamicos.push({ key: '', value: '' }); setMontagemEventos(novas);
                                }}><FaPlus size={11} style={{ marginRight: 4 }} /> Adicionar campo</button>
                            </div>
                            {montagemEvento.camposDinamicos.length === 0 && (
                                <span style={{ fontSize: 13, color: 'var(--fin-mt)' }}>Nenhum campo adicionado.</span>
                            )}
                            {montagemEvento.camposDinamicos.map((campo, i) => (
                                <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Chave" value={campo.key} onChange={e => {
                                            const novas = [...montagemEventos]; novas[index].camposDinamicos[i].key = e.target.value; setMontagemEventos(novas);
                                        }} />
                                    <input type="text" className="fin-pp__input" style={{ paddingLeft: 14, flex: 1 }}
                                        placeholder="Valor" value={campo.value} onChange={e => {
                                            const novas = [...montagemEventos]; novas[index].camposDinamicos[i].value = e.target.value; setMontagemEventos(novas);
                                        }} />
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                        const novas = [...montagemEventos]; novas[index].camposDinamicos.splice(i, 1); setMontagemEventos(novas);
                                    }}><FaTrash size={13} /></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        };

        if (dateFilter) {
            return (
                <div>
                    {montagemEventos.map((montagemEvento, index) => {
                        if (!((montagemEvento?.datas ?? []).includes(dateFilter))) return null;
                        return renderMontagemCard(montagemEvento, index);
                    })}
                </div>
            );
        }
        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Montagem + Eventos</span>
                </div>
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl">
                        <thead>
                            <tr>
                                <th style={{ width: 44 }}></th>
                                <th>Nome</th>
                                <th>Local</th>
                            </tr>
                        </thead>
                        <tbody>
                            {montagemEventos.length === 0 && (
                                <tr><td colSpan={3} className="fin-pp__empty">Nenhum item cadastrado</td></tr>
                            )}
                            {montagemEventos.map((montagemEvento, index) => (
                                <tr key={`montagem-table-${index}`}>
                                    <td>
                                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" onClick={() => {
                                            const novas = [...montagemEventos]; novas.splice(index, 1); setMontagemEventos(novas);
                                        }}><FaTrash size={13} /></button>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={montagemEvento.montagemEventoNome} onChange={(e) => {
                                                    const novas = [...montagemEventos]; novas[index].montagemEventoNome = e.target.value; setMontagemEventos(novas);
                                                }} />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="fin-pp__field">
                                            <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                                value={montagemEvento.montagemEventoLocal} onChange={(e) => {
                                                    const novas = [...montagemEventos]; novas[index].montagemEventoLocal = e.target.value; setMontagemEventos(novas);
                                                }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderObservacoes = () => (
        <div className="fin-pp__card">
            <div className="fin-pp__cphead">
                <span className="fin-pp__cphead-title">Observações Importantes</span>
                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                    onClick={() => {
                        setObservacoesGerais([...observacoesGerais, { id: nextObsId, titulo: '', texto: '' }]);
                        setNextObsId(nextObsId + 1);
                    }}>
                    <FaPlus size={12} style={{ marginRight: 6 }} /> Nova Observação
                </button>
            </div>
            <div style={{ padding: 16 }}>
                {observacoesGerais.map((obs) => (
                    <div key={obs.id} className="fin-pp__card" style={{ marginBottom: 10 }}>
                        <div className="fin-pp__cphead">
                            <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>Observação #{obs.id}</span>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                onClick={() => setObservacoesGerais(observacoesGerais.filter(item => item.id !== obs.id))}>
                                <FaTrash size={13} />
                            </button>
                        </div>
                        <div style={{ padding: 12 }}>
                            <div className="fin-pp__field" style={{ marginBottom: 8 }}>
                                <span className="fin-pp__label">Título da Observação</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    value={obs.titulo || ''} placeholder="Digite o título da observação..."
                                    onChange={(e) => setObservacoesGerais(observacoesGerais.map(item =>
                                        item.id === obs.id ? { ...item, titulo: e.target.value } : item
                                    ))} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Conteúdo da Observação</span>
                                <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px' }}
                                    value={obs.texto} placeholder="Digite o conteúdo da observação..."
                                    onChange={(e) => setObservacoesGerais(observacoesGerais.map(item =>
                                        item.id === obs.id ? { ...item, texto: e.target.value } : item
                                    ))} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    const renderInformacoesNF = () => {
        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title">Informações para Emissão de NF</span>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                        onClick={() => {
                            setInformacoesNF([...informacoesNF, { id: nextNfId, texto: '', isFixo: false }]);
                            setNextNfId(nextNfId + 1);
                        }}>
                        <FaPlus size={12} style={{ marginRight: 6 }} /> Nova Informação
                    </button>
                </div>
                <div style={{ padding: 16 }}>
                    {informacoesNF.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '32px', color: 'var(--fin-mt)' }}>
                            <FaFileInvoiceDollar size={48} style={{ marginBottom: 12 }} />
                            <p>Carregando requisitos de NF...</p>
                        </div>
                    )}
                    {informacoesNF.map((info) => (
                        <div key={info.id} className="fin-pp__card" style={{ marginBottom: 10 }}>
                            <div className="fin-pp__cphead">
                                <span style={{ fontSize: 13, color: 'var(--fin-mt)', fontWeight: 600 }}>
                                    {info.isFixo ? `Requisito Fixo #${info.id}` : `Requisito #${info.id}`}
                                </span>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                    onClick={() => setInformacoesNF(informacoesNF.filter(item => item.id !== info.id))}>
                                    <FaTrash size={13} />
                                </button>
                            </div>
                            <div style={{ padding: 12 }}>
                                <div className="fin-pp__field">
                                    <span className="fin-pp__label">{info.isFixo ? 'Requisito Fixo' : 'Informação Personalizada'}</span>
                                    <textarea className="fin-pp__input" style={{ height: 'auto', padding: '10px 14px', resize: 'vertical' }}
                                        value={info.texto} placeholder="Digite uma informação para emissão de NF..."
                                        onChange={(e) => setInformacoesNF(informacoesNF.map(item =>
                                            item.id === info.id ? { ...item, texto: e.target.value } : item
                                        ))} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // Conteúdo para cada dia do range
    const renderAbaData = (dateIso) => {
        const salasCount = salas.filter(s => (s?.datas ?? []).includes(dateIso)).length;
        const absCount = abs.filter(a => (a?.datas ?? []).includes(dateIso)).length;
        const eventosCount = eventos.filter(e => (e?.datas ?? []).includes(dateIso)).length;
        const montagemEventosCount = montagemEventos.filter(m => (m?.datas ?? []).includes(dateIso)).length;

        const addBtn = {
            salas: () => setSalas([...(salas || []), { datas: [dateIso], camposDinamicos: [] }]),
            ab: () => setAbs([...(abs || []), { datas: [dateIso] }]),
            evento: () => setEventos([...(eventos || []), { datas: [dateIso], camposDinamicos: [] }]),
            'montagem-evento': () => setMontagemEventos([...(montagemEventos || []), { datas: [dateIso], camposDinamicos: [] }]),
        };
        const addLabel = { salas: 'Adicionar Sala', ab: 'Adicionar Refeição', evento: 'Adicionar Evento', 'montagem-evento': 'Adicionar Montagem + Evento' };

        return (
            <div className="fin-pp__card">
                <div className="fin-pp__cphead">
                    <span className="fin-pp__cphead-title" style={{ textTransform: 'capitalize' }}>{formatWeekdayLong(dateIso)}</span>
                    {addBtn[subAbaAtiva] && (
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={addBtn[subAbaAtiva]}>
                            <FaPlus size={12} style={{ marginRight: 6 }} /> {addLabel[subAbaAtiva]}
                        </button>
                    )}
                </div>
                <div style={{ padding: '12px 16px' }}>
                    <div className="fin-pp__tabs" style={{ flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                        <button type="button" className={'fin-pp__tab' + (subAbaAtiva === 'salas' ? ' is-active' : '')} onClick={() => setSubAbaAtiva('salas')}>
                            Montagem de Salas <span style={{ marginLeft: 6, fontWeight: 700, color: salasCount > 0 ? 'var(--fin-ok)' : 'var(--fin-mt)' }}>{salasCount}</span>
                        </button>
                        <button type="button" className={'fin-pp__tab' + (subAbaAtiva === 'ab' ? ' is-active' : '')} onClick={() => setSubAbaAtiva('ab')}>
                            Refeição <span style={{ marginLeft: 6, fontWeight: 700, color: absCount > 0 ? 'var(--fin-ok)' : 'var(--fin-mt)' }}>{absCount}</span>
                        </button>
                        <button type="button" className={'fin-pp__tab' + (subAbaAtiva === 'evento' ? ' is-active' : '')} onClick={() => setSubAbaAtiva('evento')}>
                            Evento <span style={{ marginLeft: 6, fontWeight: 700, color: eventosCount > 0 ? 'var(--fin-ok)' : 'var(--fin-mt)' }}>{eventosCount}</span>
                        </button>
                        <button type="button" className={'fin-pp__tab' + (subAbaAtiva === 'montagem-evento' ? ' is-active' : '')} onClick={() => setSubAbaAtiva('montagem-evento')}>
                            Montagem + Evento <span style={{ marginLeft: 6, fontWeight: 700, color: montagemEventosCount > 0 ? 'var(--fin-ok)' : 'var(--fin-mt)' }}>{montagemEventosCount}</span>
                        </button>
                    </div>
                    <div>
                        {subAbaAtiva === 'salas' ? renderSalas(dateIso)
                            : subAbaAtiva === 'ab' ? renderAB(dateIso)
                            : subAbaAtiva === 'evento' ? renderEventos(dateIso)
                            : subAbaAtiva === 'montagem-evento' ? renderMontagemEventos(dateIso)
                            : null}
                    </div>
                </div>
            </div>
        );
    };

    const renderConteudoAba = () => {
        switch (abaAtiva) {
            case 'valores-acordados':
                return renderValoresAcordados();
            case 'observacoes':
                return renderObservacoes();
            case 'nf':
                return renderInformacoesNF();
            default:
                if (abaAtiva.startsWith('dia-')) {
                    const dateIso = abaAtiva.replace('dia-', '');
                    return renderAbaData(dateIso);
                }
                return renderValoresAcordados();
        }
    };

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                            onClick={() => history.push('/evento')} title="Voltar para lista de eventos">
                            <FaArrowLeft size={14} />
                        </button>
                        <div>
                            <span className="fin-pp__title">{informacoesEvento.nome || nomeEventoLS || 'Carregando...'}</span>
                            <span className="fin-pp__subtitle">
                                ID do Evento: {informacoesEvento.id || idEvento} &nbsp;|&nbsp; Ordem de Serviço: {ordemServicoId || 'N/A'}
                            </span>
                        </div>
                    </div>
                    <div className="fin-pp__actions">
                        <span style={{ fontSize: 12, color: 'var(--fin-mt)' }}>Valor Total do Evento</span>
                        <span style={{ fontSize: 20, fontWeight: 700, color: 'var(--fin-ok)' }}>{formatCurrency(calcularValorTotal())}</span>
                    </div>
                </div>

                <form className="form" onSubmit={(e) => { e.preventDefault(); salvar(); }}>
                    <div className="fin-pp__card" style={{ marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-title">Período do Evento</span>
                        </div>
                        <div className="fin-pp__filters" style={{ padding: '12px 16px' }}>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Data de Início</span>
                                <input type="date" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    id="dataInicio" value={dados.dataInicio || ''}
                                    onChange={e => setDados({ ...dados, ...{ "dataInicio": e.target.value } })} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Data Fim</span>
                                <input type="date" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    id="dataFim" value={dados.dataFim || ''}
                                    onChange={e => setDados({ ...dados, ...{ "dataFim": e.target.value } })} />
                            </div>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-title">Informações de Contato</span>
                        </div>
                        <div className="fin-pp__filters" style={{ padding: '12px 16px' }}>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Nome do Responsável</span>
                                <input type="text" className="fin-pp__input" style={{ paddingLeft: 14 }}
                                    id="contatoNome" value={contatoNome || ''}
                                    onChange={e => setContatoNome(e.target.value)} />
                            </div>
                            <div className="fin-pp__field">
                                <span className="fin-pp__label">Telefone do Responsável</span>
                                <ReactInputMask mask="(99) 99999-9999" className="fin-pp__input"
                                    style={{ paddingLeft: 14 }} id="contatoTelefone"
                                    value={contatoTelefone || ''} onChange={e => setContatoTelefone(e.target.value)} />
                            </div>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ marginBottom: 16, padding: '12px 16px' }}>
                        <div className="fin-pp__tabs" style={{ flexWrap: 'wrap', gap: 6 }}>
                            {abas.map((aba) => {
                                const count = getAbaCount(aba.id);
                                return (
                                    <button key={aba.id} type="button"
                                        className={'fin-pp__tab' + (abaAtiva === aba.id ? ' is-active' : '')}
                                        onClick={() => setAbaAtiva(aba.id)}>
                                        <span style={{ marginRight: 6 }}>{aba.icon}</span>
                                        {aba.nome}
                                        {aba.temDados !== undefined && (
                                            <span style={{ marginLeft: 4, color: aba.temDados ? 'var(--fin-ok)' : 'var(--fin-mt)' }}>
                                                {aba.temDados ? '●' : '○'}
                                            </span>
                                        )}
                                        <span style={{
                                            marginLeft: 6, fontSize: 12, fontWeight: 700,
                                            color: count > 0 ? 'var(--fin-ok)' : 'var(--fin-mt)'
                                        }}>{count}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div style={{ marginBottom: 16 }}>
                        {renderConteudoAba()}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                        <div>
                            {ordemServicoId && (
                                <button type="button" className="fin-pp__btn fin-pp__btn--ok"
                                    onClick={exportarOrdemServico} disabled={salvandoDados}>
                                    <FaFileExcel size={16} style={{ marginRight: 8 }} /> Exportar Excel
                                </button>
                            )}
                        </div>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={salvandoDados}>
                            {salvandoDados ? 'Salvando...' : (ordemServicoId ? 'Atualizar' : 'Cadastrar')}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
